import { render, staticRenderFns } from "./UpdateStaffPopUp.vue?vue&type=template&id=39bda8db&scoped=true&"
import script from "./UpdateStaffPopUp.vue?vue&type=script&lang=js&"
export * from "./UpdateStaffPopUp.vue?vue&type=script&lang=js&"
import style0 from "./UpdateStaffPopUp.vue?vue&type=style&index=0&id=39bda8db&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bda8db",
  null
  
)

export default component.exports